import { type IRole } from '../types/authType'

export const onCheckListRolePresence = (allowedRoles: IRole[], userRoles: IRole[]): boolean =>
    userRoles.filter((item1) => allowedRoles.some((item2) => item1.role === item2.role)).length > 0
